import React from 'react'
import { Dialog } from 'components/shared/Dialog'
import strings from 'strings'

function ArchiveDialog({ open, applicantName, onConfirm, onClose }) {
    const contentMessage = `${strings.APPLICANT.CONFIRM_ARCHIVE} ${applicantName}?`

    return (
        <Dialog
            fullWidth
            maxWidth='sm'
            type='warning'
            open={open}
            contentMessage={contentMessage}
            confirmButton={{ text: strings.CONFIRM_ARCHIVE }}
            alertTiltle={strings.APPLICANT.ARCHIVE_APPLICATION}
            onSubmit={onConfirm}
            onClose={onClose}
        />
    )
}

export default ArchiveDialog